<div appClickable class="relative" (click)="$event.stopPropagation()">
  <div class="flex items-center border-b border-line">
    <div class="flex items-center px-sm text-light-text">
      <ic-search [height]="'18'" [width]="'18'"></ic-search>
    </div>
    <input
      #searchInput
      type="text"
      class="w-full outline-none h-[64px] text-lg text-dark-text bg-transparent placeholder:text-light-text"
      [value]="searchQuery"
      (input)="onSearchInput($event)"
      (keydown.enter)="onSearchSubmit()"
      [placeholder]="'globalSearchPlaceholder' | translate"
    />
    @if (searchQuery) {
    <button
      type="button"
      (click)="clearSearch($event)"
      class="px-sm text-light-text hover:text-gray-700 transition-colors cursor-pointer"
    >
      <ic-close [height]="'14'" [width]="'14'"></ic-close>
    </button>
    }
  </div>

  <div class="max-h-[500px] overflow-y-auto">
    <!-- 🔹 Loader -->
    @if (loading()) {
    <div class="flex flex-col items-center justify-center py-xl gap-sm">
      <i class="pi pi-spin pi-spinner text-primary text-2xl"></i>
      <span class="text-xs text-light-text font-medium">{{
        'searchingRecords' | translate
      }}</span>
    </div>
    }

    <!-- 🔹 Results -->
    @else if (searchResults().length > 0) {
    <div class="p-xs">
      @for (result of searchResults(); track result.id) {
      <button
        type="button"
        (click)="onSearchResultSelect(result)"
        class="w-full text-left p-sm hover:bg-gray-50 transition-all rounded-xl flex items-start gap-sm group cursor-pointer"
      >
        <div
          class="w-10 h-10 rounded-xl bg-primary/5 flex items-center justify-center shrink-0 group-hover:bg-primary/10 transition-colors"
        >
          @switch (normalizeSourceTable(result.source_table)) {
          @case ('shipments') {
          <i class="pi pi-map text-primary text-lg opacity-70"></i>
          } @case ('declarations') {
          <i class="pi pi-file text-primary text-lg opacity-70"></i>
          } @case ('users') {
          <i class="pi pi-user text-primary text-lg opacity-70"></i>
          } @case ('deliveries') {
          <i class="pi pi-truck text-primary text-lg opacity-70"></i>
          } @case ('declaration_items') {
          <i class="pi pi-box text-primary text-lg opacity-70"></i>
          } @case ('delivery_items') {
          <i class="pi pi-box text-primary text-lg opacity-70"></i>
          } @case ('transit_arrival') {
          <i class="pi pi-arrow-circle-down text-primary text-lg opacity-70"></i>
          } @case ('transit_departure') {
          <i class="pi pi-arrow-circle-up text-primary text-lg opacity-70"></i>
          } @case ('transit_declarations') {
          <i class="pi pi-send text-primary text-lg opacity-70"></i>
          } @case ('emcs') {
          <i class="pi pi-shield text-primary text-lg opacity-70"></i>
          } @case ('tickets') {
          <i class="pi pi-ticket text-primary text-lg opacity-70"></i>
          } @case ('rto') {
          <i class="pi pi-building text-primary text-lg opacity-70"></i>
          } @case ('brokers') {
          <i class="pi pi-briefcase text-primary text-lg opacity-70"></i>
          } @case ('clients') {
          <i class="pi pi-id-card text-primary text-lg opacity-70"></i>
          } @case ('parties') {
          <i class="pi pi-users text-primary text-lg opacity-70"></i>
          } @case ('roles') {
          <i class="pi pi-key text-primary text-lg opacity-70"></i>
          } @default {
          <i class="pi pi-search text-primary text-lg opacity-70"></i>
          } }
        </div>

        <div class="flex flex-col min-w-0 flex-1 py-0.5">
          <div class="flex items-center justify-between gap-sm mb-0.5">
            <span class="text-sm font-semibold text-dark-text truncate">
              {{ result.title }}
            </span>
            <span
              class="text-[10px] px-1.5 py-0.5 rounded-full bg-gray-100 text-gray-500 uppercase font-bold tracking-wider shrink-0"
            >
              {{ formatSourceTable(result.source_table) }}
            </span>
          </div>
          <span class="text-xs text-light-text truncate">
            {{ result.subtitle }}
          </span>
        </div>

        <div
          class="shrink-0 self-center opacity-0 group-hover:opacity-100 transition-opacity"
        >
          <i class="pi pi-chevron-right text-xs text-light-text"></i>
        </div>
      </button>
      }
    </div>
    }

    <!-- 🔹 No Data -->
    @else if (searchQuery && !loading()) {
    <app-empty-state
      [title]="'noResultsFound' | translate"
      [subtitle]="('noResultsForQuery' | translate) + ' &quot;' + searchQuery + '&quot;'"
      [size]="150"
    ></app-empty-state>
    }

    <!-- 🔹 Initial state -->
    @else {
    <div class="p-xl text-center text-light-text">
      <p class="text-sm font-medium">{{ 'typeToStartSearching' | translate }}</p>
      <p class="text-xs mt-1">
        {{ 'searchAcrossAllModules' | translate }}
      </p>
    </div>
    }
  </div>
</div>
